(function () {
  // Muted looping videos only load and play while on screen, so they never slow the first load.
  function init() {
    var videos = document.querySelectorAll('video[data-puvo-autoplay]:not([data-puvo-ready])');
    if (!videos.length) return;

    var volumeSupported = (function () {
      var probe = document.createElement('video');
      try {
        probe.volume = 0.5;
      } catch (error) {
        return false;
      }
      return probe.volume === 0.5;
    })();

    var observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                var video = entry.target;
                if (entry.isIntersecting) {
                  // Respect a visitor's pause: don't restart when it scrolls back into view.
                  if (video.dataset.puvoUserPaused === 'true') return;
                  var playing = video.play();
                  if (playing && playing.catch) playing.catch(function () {});
                } else {
                  video.pause();
                }
              });
            },
            { threshold: 0.25 }
          )
        : null;

    videos.forEach(function (video) {
      video.setAttribute('data-puvo-ready', '');
      video.muted = true;

      var frame = video.parentElement;
      var controls = frame && frame.querySelector('[data-puvo-controls]');
      var soundButton = frame && frame.querySelector('[data-puvo-sound]');
      var volumeSlider = frame && frame.querySelector('[data-puvo-volume]');
      var playButton = frame && frame.querySelector('[data-puvo-play]');

      function updatePlayButton() {
        if (!playButton) return;
        var paused = video.dataset.puvoUserPaused === 'true';
        playButton.setAttribute('aria-pressed', String(paused));
        playButton.setAttribute('aria-label', paused ? 'Afspil video' : 'Sæt video på pause');
      }

      if (playButton) {
        playButton.addEventListener('click', function () {
          if (video.dataset.puvoUserPaused === 'true') {
            video.dataset.puvoUserPaused = 'false';
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          } else {
            video.dataset.puvoUserPaused = 'true';
            video.pause();
          }
          updatePlayButton();
        });
      }
      var collapseTimer = null;
      var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;

      // iPhone/iPad don't let websites set the volume (the hardware buttons do),
      // so only the sound on/off icon is shown there.
      if (controls && !volumeSupported) controls.classList.add('no-volume');

      function updateButton() {
        if (!soundButton) return;
        soundButton.setAttribute('aria-pressed', String(!video.muted));
        soundButton.setAttribute('aria-label', video.muted ? 'Slå lyd til' : 'Slå lyd fra');
      }

      function collapse() {
        clearTimeout(collapseTimer);
        if (controls) controls.classList.remove('is-expanded');
      }

      // Hide the volume slider 2 seconds after the last interaction, unless the
      // pointer is still over the controls or the slider has keyboard focus.
      function scheduleCollapse() {
        clearTimeout(collapseTimer);
        collapseTimer = setTimeout(function () {
          var hovered = canHover && controls.matches(':hover');
          var focused = document.activeElement === volumeSlider;
          if (hovered || focused) {
            scheduleCollapse();
          } else {
            collapse();
          }
        }, 2000);
      }

      function expand() {
        if (!controls || !volumeSlider || !volumeSupported || video.muted) return;
        controls.classList.add('is-expanded');
        scheduleCollapse();
      }

      if (soundButton) {
        soundButton.addEventListener('click', function () {
          video.muted = !video.muted;
          if (!video.muted && video.volume === 0) {
            video.volume = 1;
            if (volumeSlider) volumeSlider.value = '1';
          }
          if (!video.muted && video.paused && video.dataset.puvoUserPaused !== 'true') {
            var playing = video.play();
            if (playing && playing.catch) playing.catch(function () {});
          }
          updateButton();
          if (video.muted) {
            collapse();
          } else {
            expand();
          }
        });
      }

      if (volumeSlider) {
        volumeSlider.addEventListener('input', function () {
          var level = Number(volumeSlider.value);
          video.volume = level;
          video.muted = level === 0;
          updateButton();
          controls.classList.add('is-expanded');
          scheduleCollapse();
        });
        volumeSlider.addEventListener('focus', expand);
        volumeSlider.addEventListener('blur', scheduleCollapse);
      }

      if (controls && canHover) {
        controls.addEventListener('mouseenter', expand);
        controls.addEventListener('mouseleave', function () {
          if (controls.classList.contains('is-expanded')) scheduleCollapse();
        });
      }

      updateButton();
      updatePlayButton();
      if (observer) {
        observer.observe(video);
      } else {
        video.play();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
